import styled from "styled-components";
import AntSteps from "antd/es/steps";

const Steps = styled(AntSteps)`
  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title,
  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    color: ${(p) => p.theme.colors.textColor};
  }
  .ant-steps-item-wait
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    color: ${(p) => p.theme.colors.disabledText};
  }
  .ant-steps-item-wait .ant-steps-item-icon {
    background: ${(p) => p.theme.colors.cardBgColor};
    border-color: ${(p) => p.theme.colors.disabledText};
  }
  .ant-steps-item-wait .ant-steps-item-icon .ant-steps-icon {
    color: ${(p) => p.theme.colors.disabledText};
  }

  .ant-steps-item-process .ant-steps-item-icon {
    background: ${(p) => p.theme.colors.primaryBlue};
    border-color: ${(p) => p.theme.colors.primaryBlue};
  }

  &.ant-steps.ant-steps-with-progress
    .ant-steps-item-process
    .ant-steps-item-container
    .ant-steps-item-icon
    .ant-steps-icon {
    color: ${(p) => p.theme.colors.layoutBgColor}!important;
  }

  .ant-steps-item-finish .ant-steps-item-icon {
    background: ${(p) => p.theme.colors.cardBgColor};
    border-color: ${(p) => p.theme.colors.primaryBlue};
  }
  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: ${(p) => p.theme.colors.primaryBlue};
  }

  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after,
  .ant-steps-item-wait
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after {
    background: ${(p) => p.theme.colors.disabledText};
  }
  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after {
    background: ${(p) => p.theme.colors.primaryBlue};
  }
  .ant-progress-status-success
    .ant-progress-inner:not(.ant-progress-circle-gradient)
    .ant-progress-circle-path {
    stroke: ${(p) => p.theme.colors.primaryBlue};
  }

  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-tail::after {
    background: ${(p) => p.theme.colors.primaryBlue};
  }
`;

export default Steps;
